
import React, { Component } from 'react';

export class IBZW extends Component {

    render() {
        return (
            <div>
                <h1 align='center'>IBZ Web department</h1>
                <br />
                <p>This was a legacy division which is now rebranded and suceeded by Fevid, it was primaryliy exploring the various different hosting options out there for web apps, most of it's services have been taken down</p>
                <h2 align="center">Links</h2>
                <ul>
                    <li><b>Main Website </b><a href='https://ibz.vercel.app/EN'>https://ibz.vercel.app/EN</a></li>
                   
                </ul>
            </div>
        );
    }
}

